import { parse, format, resolve } from 'url';
import { deprecation } from './logging/deprecation.mjs';

const url = {
  get parse() {
    deprecation("7.3.0", "utils.url.parse is deprecated, use native URL API instead.");
    return parse;
  },
  get format() {
    deprecation("7.3.0", "utils.url.format is deprecated, use native URL API instead.");
    return format;
  },
  get resolve() {
    deprecation("7.3.0", "utils.url.resolve is deprecated, use native URL API instead.");
    return resolve;
  }
};

export { url };
//# sourceMappingURL=url.mjs.map
